// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-blue-25: #ebf6ff;
    --primary-blue-100: #0ab6ed;
    --primary-blue-200: #2c9cff;
    --primary-blue-300: #2297ff;
    --primary-blue-400: #2184db;
    --primary-blue-450: #005fb2;
    --primary-blue-500: #004b8d;
    --primary-blue-600: #003c71;
    --primary-blue-700: #002d55;
    --primary-blue-750: #002547;
    --primary-blue-800: #001e38;
    --error-500: #f04438;
    --error-700: #d60000;
    --success-500: #00a651;
    --success-600: #008f46;
    --neutrals-15: #fff;
    --neutrals-25: #fcfcfd;
    --warning-500: #faad14;
    --shadow-primary: 0px 2px 12px 0px rgba(1, 19, 36, 0.12);
}

.inter {
    font-family: 'Inter';
}

* {
    font-family: 'Inter';
}

h1.heading {
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 34px; /* 141.667% */
}

h2.subheading {
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 24px; /* 150% */
    letter-spacing: 0.32px;
}

h3.body {
    /* Body/Desktop/H2/Regular */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
}

h3.body-bold {
    /* Body/Desktop/H2/Regular */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px; /* 142.857% */
    margin: 0;
}

h5.body {
    /* Body/Desktop/H3/Regular */
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    margin: 0;
}

h4.body,
span.body {
    /* Body/Desktop/H3/Bold */
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 150% */
    margin: 0;
}

.app-container {
    display: flex;
    font-family: 'Inter';
}

.ant-input::placeholder {
    color: #212529 !important;
    opacity: 0.5 !important;
}

.ant-select-selection-placeholder {
    color: #212529 !important;
    opacity: 0.5 !important;
}

.app-container {
    background-color: #f5f5f5 !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,wDAAwD;AAC5D;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;AACpC;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,SAAS;AACb;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n:root {\n    --primary-blue-25: #ebf6ff;\n    --primary-blue-100: #0ab6ed;\n    --primary-blue-200: #2c9cff;\n    --primary-blue-300: #2297ff;\n    --primary-blue-400: #2184db;\n    --primary-blue-450: #005fb2;\n    --primary-blue-500: #004b8d;\n    --primary-blue-600: #003c71;\n    --primary-blue-700: #002d55;\n    --primary-blue-750: #002547;\n    --primary-blue-800: #001e38;\n    --error-500: #f04438;\n    --error-700: #d60000;\n    --success-500: #00a651;\n    --success-600: #008f46;\n    --neutrals-15: #fff;\n    --neutrals-25: #fcfcfd;\n    --warning-500: #faad14;\n    --shadow-primary: 0px 2px 12px 0px rgba(1, 19, 36, 0.12);\n}\n\n.inter {\n    font-family: 'Inter';\n}\n\n* {\n    font-family: 'Inter';\n}\n\nh1.heading {\n    font-family: Inter;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 800;\n    line-height: 34px; /* 141.667% */\n}\n\nh2.subheading {\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.32px;\n}\n\nh3.body {\n    /* Body/Desktop/H2/Regular */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n}\n\nh3.body-bold {\n    /* Body/Desktop/H2/Regular */\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px; /* 142.857% */\n    margin: 0;\n}\n\nh5.body {\n    /* Body/Desktop/H3/Regular */\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px; /* 150% */\n    margin: 0;\n}\n\nh4.body,\nspan.body {\n    /* Body/Desktop/H3/Bold */\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 18px; /* 150% */\n    margin: 0;\n}\n\n.app-container {\n    display: flex;\n    font-family: 'Inter';\n}\n\n.ant-input::placeholder {\n    color: #212529 !important;\n    opacity: 0.5 !important;\n}\n\n.ant-select-selection-placeholder {\n    color: #212529 !important;\n    opacity: 0.5 !important;\n}\n\n.app-container {\n    background-color: #f5f5f5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
